import Modal from 'react-modal';
import btnX from '../../icon/x_button_bg.svg';
import { onToggleModal } from '../../utils/utils';

export const CustomModal = ({ children, width, padding = 'p-[32px]', title, setIsOpen }) => {
  const handleClose = () => onToggleModal(setIsOpen);

  return (
    <Modal
      isOpen
      onRequestClose={handleClose}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      className={`${width} max-h-[90vh] max-w-[calc(100vw-32px)] overflow-hidden rounded-[12px] bg-white outline-none`}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px',
          zIndex: 60,
        },
        content: {
          position: 'static',
          inset: 'auto',
          border: 'none',
          background: '#FFFFFF',
          padding: 0,
          overflow: 'visible',
        },
      }}
    >
      <div className="flex max-h-[90vh] flex-col overflow-hidden">
        <div className="flex flex-shrink-0 items-center justify-between border-b border-[#E5E7EB] px-[24px] py-[20px] md:px-[30px]">
          <p className="text-[18px] font-[350] md:text-[20px]">{title}</p>
          <button type="button" onClick={handleClose} aria-label="닫기 버튼" className="rounded-full p-1 hover:bg-[#F3F4F6]">
            <img src={btnX} aria-hidden="true" />
          </button>
        </div>
        <div className={`min-h-0 flex-1 overflow-y-auto ${padding}`}>
          <div className="mx-[16px] md:mx-0">{children}</div>
        </div>
      </div>
    </Modal>
  );
};

export default CustomModal;
